import { Link } from 'react-router';
import { cn } from '@rocco/utils/cn';
interface HDEPresentedByMarkProps {
    /** Sponsor logo from EventDetails.PresentedBy (CMS). */
    logoUrl?: string | null;
    /** Profile link when EventDetails.PresentedByProfessional is set. */
    profilePath?: string | null;
    sponsorName?: string | null;
    className?: string;
    /** Tailwind classes for the CMS image (width/height). */
    imageClassName: string;
}

/**
 * Renders the HDE “Presented by” mark from the CMS logo. Renders nothing when no logo is set.
 */
export const HDEPresentedByMark = ({
    logoUrl,
    profilePath,
    sponsorName,
    className,
    imageClassName,
}: HDEPresentedByMarkProps) => {
    const trimmedLogo = logoUrl?.trim() || '';
    if (trimmedLogo === '') {
        return null;
    }
    const path = profilePath?.trim() || '';
    const name = sponsorName?.trim() || '';

    const mark = (
        <img
            src={trimmedLogo}
            alt=""
            className={cn(
                'h-auto max-w-full object-contain brightness-0 invert',
                imageClassName,
            )}
        />
    );

    if (path !== '') {
        return (
            <Link
                to={path}
                aria-label={
                    name !== ''
                        ? `Visit ${name} profile`
                        : 'Visit sponsor profile'
                }
                className={cn('inline-block', className)}
            >
                {mark}
            </Link>
        );
    }

    return (
        <span className={cn('inline-block', className)} role="presentation">
            {mark}
        </span>
    );
};
